import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'
import { makeStyles } from '@material-ui/core'
import ToggleButton from './ToggleButton'

const useStyles = makeStyles({
  buttonGroup: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 0,
    paddingBottom: 10,
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    '& > button': {
      backgroundColor: '#F3F3F3',
      padding: '8px 12px',
      marginRight: 10,
      borderRadius: 20,
      border: 'none',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    },
    '& :focus': {
      outline: 'none',
    },
  },
})

interface FundamentalToggleGroupProps {
  toggleObj: any
  setToggleObj: any
}

const FundamentalToggleGroup = forwardRef(
  ({ toggleObj, setToggleObj }: FundamentalToggleGroupProps, ref) => {
    const classes = useStyles()
    const [fundamentalToggle, setFundamentalToggle] = useState(toggleObj)

    const updateFundamentalToggle = (toggle: any) => {
      setFundamentalToggle(toggle)
    }

    useImperativeHandle(ref, () => {
      return {
        updateFundamentalToggle,
      }
    })

    useEffect(() => {
      setFundamentalToggle(toggleObj)
    }, [toggleObj])

    const handleChangeFilterByType = (type: string) => {
      if (type === 'companyHistory') {
        setToggleObj({
          ...fundamentalToggle,
          showCompanyHistory: !fundamentalToggle.showCompanyHistory,
        })
      } else {
        setToggleObj({
          ...fundamentalToggle,
          showPeerGroup: !fundamentalToggle.showPeerGroup,
        })
      }
    }

    return (
      <div className={classes.buttonGroup}>
        <ToggleButton
          toggleState={fundamentalToggle.showCompanyHistory}
          activeColor="#32AE6C"
          inactiveColor="rgb(209, 209, 209)"
          setToggleValue={() => handleChangeFilterByType('companyHistory')}
          title="Company history"
          spaceRight={8}
          spaceLeft={0}
        />
        <ToggleButton
          toggleState={fundamentalToggle.showPeerGroup}
          activeColor="#D24670"
          inactiveColor="rgb(209, 209, 209)"
          setToggleValue={() => handleChangeFilterByType('peerGroup')}
          title="Peer Group"
          spaceRight={0}
          spaceLeft={0}
        />
      </div>
    )
  },
)

export default FundamentalToggleGroup
